<template>
  <div v-bind:class="{ 'routing-modal-container': true, show: modal.show }" @click="close">
    <div class="routing-modal">
      <div class="routing-modal-content">
        <div v-bind:class="{ 'validation-modal': true }" v-show="modal.validation.show" @click.stop>
          <div class="title">{{ modal.validation.title }}</div>
          <div class="message">{{ modal.validation.message }}</div>
          <a class="button small cta" href="javascript:;" @click="close">OK, GOT IT.</a>
        </div>
        <div v-bind:class="{
                'ajax-modal': true,
                error: !modal.ajax.loading && !modal.ajax.success,
                success: !modal.ajax.loading && modal.ajax.success
              }" v-show="modal.ajax.show" @click.stop>
          <i class="fas fa-circle-notch fa-spin fa-3x" v-show="modal.ajax.loading"></i>
          <i class="fas fa-times-circle fa-3x" v-show="!modal.ajax.loading && !modal.ajax.success"></i>
          <i class="fas fa-check-circle fa-3x" v-show="!modal.ajax.loading && modal.ajax.success"></i>
          <div class="message">{{ modal.ajax.message }}</div>
        </div>
        <div class="confirmation-modal" v-show="modal.confirmation.show" @click.stop>
          <div class="title">{{ modal.confirmation.title }}</div>
          <div v-show="!hasMultipleDrivers">
            <div class="message" v-html="modal.confirmation.message"></div>
            <div class="row controls">
              <div class="small-6 columns padding-R" v-show="modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER'">
                <a href="javascript:;" class="button cta small block" @click="closeAction">UNASSIGN IT.</a>
              </div>
              <div v-bind:class="{
                'columns': true,
                'small-6 padding-L': modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER',
                'small-12': modal.confirmation.action === 'SAVE_PACKAGE'
              }">
                <a href="javascript:;" class="button cta small success block" @click="confirmAction">YES, I DO.</a>
              </div>
            </div>
          </div>
          <div v-show="hasMultipleDrivers" class="text-left">
            <div class="message" v-html="modal.confirmation.message"></div>
            <div class="drivers">
              <div class="driver" v-for="(item, index) in dropzoneDrivers">
                <a :href="'/#/provider/' + item.driver.ID" target="_blank" @click.stop>{{ item.driver.ID }}</a>
                <a href="javascript:;" class="name" @click="savePackage(item.driver.ID)">{{ item.driver.firstName }} {{ item.driver.lastName }}</a>
              </div>
              <div class="driver">
                <a href="javascript:;" @click="savePackage(null)">I'll assign this package later.</a>
              </div>
            </div>
          </div>
          <a class="close-button" href="javascript:;" @click="close">Cancel my changes.</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'routing-modal',
  computed: {
    modal () { return this.$store.state.routing.routingModal },
    hasMultipleDrivers () { return this.$store.state.routing.dropzone.drivers.length > 1 },
    dropzoneDrivers () { return this.$store.state.routing.dropzone.drivers },
  },
  methods: {
    close () {
      if (this.$store.state.routing.routingModal.ajax.show) {
        return
      }
      this.$store.commit('routing/hideRoutingModal')
    },
    confirmAction () {
      let self = this
      let action = self.modal.confirmation.action
      if (action === 'SAVE_RUN') {
        self.saveRun()
        return
      }
      if (action === 'BREAK_RUN') {
        self.breakRun()
        return
      }
      if (action === 'SAVE_PACKAGE') {
        self.savePackage(null)
        return
      }
      if (action === 'SAVE_PACKAGE_KEEP_DRIVER') { // There's only one driver
        let driver = self.$store.state.routing.dropzone.drivers[0].driver
        self.savePackage(driver.ID)
        return
      }
    },
    closeAction () {
      let self = this
      let action = self.modal.confirmation.action
      if (action === 'SAVE_PACKAGE_KEEP_DRIVER') {
        self.savePackage(null)
        return
      }
      if (this.$store.state.routing.routingModal.ajax.show) {
        return
      }
      this.$store.commit('routing/hideRoutingModal')
    },
    savePackage (provId) {
      let self = this
      let stops = self.$store.state.routing.dropzone.items

      self.$store.commit('routing/resetConfirmationModal')
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Saving package...'
      })

      let request = {
        token: self.$store.state.session.sessionToken,
        provId: provId,
        items: []
      }
      for (let i = 0; i < stops.length; i++) {
        request.items.push({
          rsvpId: stops[i].reservationID,
          pickup: stops[i].isPickup,
          eta: stops[i].eta,
          maxDuration: stops[i].maxDuration
        })
      }

      self.$sdk.post('/admin/package/save', request, r => {
        let success = true
        let message = 'Successfully saved package!'
        if (r.error) {
          console.log(r)
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        }

        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        if (success) {
          self.$store.commit('routing/clearDropzone')
        }

        setTimeout(() => {
          self.$store.commit('routing/hideRoutingModal')
        }, 1000)
      })
    },
    saveRun () {
      // console.log('SAVE RUN')
      let self = this

      let items = self.$store.state.runs.dropzone.items
      let runIds = []
      let resIds = []

      // console.log('J', items)
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (item.runId) {
          if (runIds.indexOf(item.runId) < 0) {
            runIds.push(item.runId)
          }
        }
        let res = { reservationId: item.id }
        if (item.distanceToNext !== null) {
          res['nextPickupMiles'] = item.distanceToNext
        }
        resIds.push(res)
      }

      self.$store.commit('routing/resetConfirmationModal')
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Saving run...'
      })

      // break existing
      if (runIds.length > 0) {
        self.$sdk.post('/runs/break', {
          token: self.$store.state.session.sessionToken,
          runId: runIds
        }, r => {
          console.log('BREAK', r)
          if (r.error) {
            self.$store.commit('routing/setRoutingAjaxModal', {
              show: true,
              loading: false,
              success: false,
              message: 'Oops. Something went wrong. Please try again later.'
            })
          }

          self.$sdk.post('/runs/create', {
            token: self.$store.state.session.sessionToken,
            run: resIds
          }, r => {
            console.log('CREATE', r)
            let success = true
            let message = 'Successfully saved run!'
            if (r.error) {
              success = false
              message = 'Oops. Something went wrong. Please try again later.'
            }

            self.$store.commit('routing/setRoutingAjaxModal', {
              show: true,
              loading: false,
              success: success,
              message: message
            })

            if (success) {
              self.$store.commit('runs/clearDropzone')
            }

            self.$store.commit('runs/setRunsDetails', {refresh: true})

            setTimeout(() => {
              self.$store.commit('routing/hideRoutingModal')
            }, 1000)
          }, '2.0')

        }, '2.0')
        return
      }

      self.$sdk.post('/runs/create', {
        token: self.$store.state.session.sessionToken,
        run: resIds
      }, r => {
        console.log('CREATE', r)
        let success = true
        let message = 'Successfully saved run!'
        if (r.error) {
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        }

        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        if (success) {
          self.$store.commit('runs/clearDropzone')
        }

        self.$store.commit('runs/setRunsDetails', {refresh: true})

        setTimeout(() => {
          self.$store.commit('routing/hideRoutingModal')
        }, 1000)
      }, '2.0')
    },
    breakRun () {
      let self = this

      self.$store.commit('routing/resetConfirmationModal')
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Breaking run...'
      })

      self.$sdk.post('/runs/break', {
        token: self.$store.state.session.sessionToken,
        runId: self.$store.state.runs.breakIds
      }, r => {
        if (r.error) {
          self.$store.commit('routing/setRoutingAjaxModal', {
            show: true,
            loading: false,
            success: false,
            message: 'Oops. Something went wrong. Please try again later.'
          })
          return
        }

        self.$store.state.runs.breakIds.forEach(x => {
          self.$store.commit('runs/removeRunsInMap', x)
        })
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: true,
          message: 'Successfully break run!'
        })

        self.$store.commit('runs/setRunsDetails', {refresh: true})

        setTimeout(() => {
          self.$store.commit('routing/hideRoutingModal')
        }, 1000)
      }, '2.0')
    }
  }
}
</script>

<style lang="scss" scoped>
.routing-modal-container {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.routing-modal {
  display: table-cell;
  vertical-align: middle;
}

.routing-modal-content {
  position: relative;
  background-color: #fff;
  border-radius: 3px;
  width: 350px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
  transition: all 250ms;
}

.ajax-modal {
  padding: 15px;
  & i { color: #777; display: block; margin-bottom: 10px; }
  & .message { font-weight: 700;  color: #555; }

  &.success i { color: #26D97A; }
  &.error i { color: #F20D0D; }
}

.validation-modal {
  & .title {
    background-color: #333;
    color: #fff;
    padding: 10px;
  }

  & .message {
    font-weight: 700;
    color: #555;
    padding: 20px;
  }

  & .button {
    margin-bottom: 15px;
  }
}

.confirmation-modal {
  & .title {
    background-color: #333;
    color: #fff;
    padding: 10px;
  }

  & .message {
    font-weight: 700;
    color: #555;
    padding: 15px 20px 20px;
  }

  & .controls {
    padding: 0 20px 0px;
  }

  & .close-button {
    display: block;
    font-weight: 700;
    padding: 10px 15px 15px;
    font-size: 12px;
  }

  & .text-left{
    text-align: left;
    & .message {
      font-size: 14px;
      padding: 15px;
    }
  }

  & .drivers {
    padding: 0 15px;

    & .driver {
      padding: 10px 15px;
      margin-bottom: 5px;
      background-color: #f5f5f5;
      border-radius: 3px;
      font-size: 14px;
      border: 1px solid rgba(0,0,0,0.3);

      & a {
        font-weight: 700;
        display: inline-block;
        margin-right: 5px;
      }

      & .name { font-weight: 700; text-decoration: none; }
    }
  }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
</style>



// WEBPACK FOOTER //
// src/components/Routing/RoutingModal.vue